module.exports = __webpack_public_path__ + "d18d5444e814989a7e3104d84379388f.pdf";